module.exports = __webpack_public_path__ + "static/media/color.ef76dbdd.svg";